import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import TableText from "../../TableText";
import { toJS, runInAction, } from 'mobx';
import Total from "../Total";
import Rooms from "../Rooms";

const totalIndex = [];

@inject('store')
@observer
class index extends Component {

    componentDidMount() {
        const { getData, date } = this.props.store.daily;
        getData(date);
    }

    onChange = (name, value, i) => {
        let { roomData, dayData, foodData } = this.props.store.daily;
        let data = [...toJS(foodData)];
        data[i][name] = value;
        this.props.store.daily.onChange({
            roomData, foodData: data, dayData
        });
    }

    render() {
        const { print, loading, foodData, saveLoading } = this.props.store.daily;
        const columns = [
            {
                title: <span>Food&Beverage<br /> 餐饮</span>,
                dataIndex: 'name',
                key: 'name',
                align: "center",
                // width: 200,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex,

                    };

                    return <TableText data={{ ...props }} />
                }
            }, {
                title: <span>Today<br /> 今日实际</span>,
                children: [{
                    title: <span>Actual<br /> 实际收入</span>,
                    dataIndex: 'actual',
                    key: 'actual',
                    align: "center",
                    // width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: 'inputNumber', name: "actual", onChange: this.onChange, totalIndex,
                            compared: {
                                title: ['Today<br /> 今日实际', "Actual<br /> 实际收入"],
                                record,
                                sqlName: "daily"
                            }
                        };
                        if (index == 10) props.type = "number";
                        return <TableText data={{ ...props }} />
                    }
                }, {
                    title: <span>Covers<br /> 人数</span>,
                    dataIndex: 'covers',
                    key: 'covers',
                    align: "center",
                    // width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: 'inputNumber', name: "covers", onChange: this.onChange, totalIndex,
                            compared: {
                                title: ['Today<br /> 今日实际', "Covers<br /> 人数"],
                                record,
                                sqlName: "daily"
                            }
                        };
                        if (index == 10) props.type = "number";
                        if (index == 9) props.type = "";
                        return <TableText data={{ ...props }} />
                    }
                }, {
                    title: <span>Average Check<br /> 人均消费</span>,
                    dataIndex: 'average',
                    key: 'average',
                    align: "center",
                    // width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: 'number', name: "average", onChange: this.onChange, totalIndex,
                            compared: {
                                title: ['Today<br /> 今日实际', "Average Check<br /> 人均消费"],
                                record,
                                sqlName: "daily"
                            }
                        };
                        if (index == 9) props.type = "";
                        return <TableText data={{ ...props }} />
                    }
                }]

            }, {
                title: <span>Last Year <br /> 去年当日</span>,
                children: [{
                    title: <span>Actual<br /> 实际收入</span>,
                    dataIndex: 'last_actual',
                    key: 'last_actual',
                    align: "center",
                    // width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: 'inputNumber', name: "last_actual", onChange: this.onChange, totalIndex,
                            compared: {
                                title: ['Last Year <br /> 去年当日', "Actual<br /> 实际收入"],
                                record,
                                sqlName: "daily"
                            }
                        };
                        if (index == 10) props.type = "number";
                        return <TableText data={{ ...props }} />
                    }
                }, {
                    title: <span>Covers<br /> 人数</span>,
                    dataIndex: 'last_covers',
                    key: 'last_covers',
                    align: "center",
                    // width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: 'inputNumber', name: "last_covers", onChange: this.onChange, totalIndex,
                            compared: {
                                title: ['Last Year <br /> 去年当日', "Covers<br /> 人数"],
                                record,
                                sqlName: "daily"
                            }
                        };
                        if (index == 10) props.type = "number";
                        if (index == 9) props.type = "";
                        return <TableText data={{ ...props }} />
                    }
                }, {
                    title: <span>Average Check<br /> 人均消费</span>,
                    dataIndex: 'last_average',
                    key: 'last_average',
                    align: "center",
                    // width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: 'number', name: "last_average", onChange: this.onChange, totalIndex,
                            compared: {
                                title: ['Last Year <br /> 去年当日', "Average Check<br /> 人均消费"],
                                record,
                                sqlName: "daily"
                            }
                        };
                        if (index == 9) props.type = "";
                        return <TableText data={{ ...props }} />
                    }
                }]

            },
        ]

        return (
            <div className="table7_1_1 ">

                <div id="daily">
                    <Row className="title">
                        <Row > Daily Revenue Report 每日经营报表</Row>
                        <Row className="table-month">
                            <DatePicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.props.store.daily.date, "YYYY-MM-DD")}
                                format="YYYY-MM-DD"
                                onChange={(date, str) => {
                                    this.props.store.daily.getData(str);
                                    runInAction(() => {
                                        this.props.store.daily.date = str;
                                    })
                                }}
                            /> </Row>
                    </Row>

                    <div className="daily">
                        <div className="month">
                            <Rooms />
                        </div>
                        <div className="day">
                            <Row className="title" id="table4_1_1" >
                                <Table
                                    columns={columns}
                                    dataSource={toJS(foodData)}
                                    size="middle"
                                    bordered
                                    pagination={false}
                                    loading={loading}
                                    className="content"
                                    rowKey={(record, index) => index}
                                />
                            </Row>

                        </div>
                    </div>

                    <Total />
                </div>
                <Row className="table-footer-btn">
                    {/* <Button
                        type="primary"
                        onClick={download}
                        loading={print}
                        style={{
                            marginRight: 10
                        }}
                    >导出</Button> */}
                    {!print && <Button
                        type="primary"
                        onClick={this.props.store.daily.onSave}
                        loading={saveLoading}
                    >保存</Button>}
                </Row>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/daily/Food/index.js